function Scriptureguide() {
  return <div>Scripture guide Israel</div>;
}

export default Scriptureguide;
